<template>
    <k-panel class="border">
        <k-panel-header slot="header">
            <div slot="left">{{ $t("changePassword") }}</div>
            <div slot="right"></div>
        </k-panel-header>
        <form autocomplete="off">
            <k-input
                class="mb-4"
                id="currentPassword"
                label="Current password"
                v-model="changePasswordForm.currentPassword"
                :field-errors="validation.fieldErrors"
                type="password"/>
            <k-input
                class="mb-4"
                id="newPassword"
                label="New password"
                v-model="changePasswordForm.newPassword"
                :field-errors="validation.fieldErrors"
                type="password"/>
            <k-input
                class="mb-4"
                id="newPasswordRepeat"
                label="Repeat password"
                v-model="changePasswordForm.newPasswordRepeat"
                :field-errors="validation.fieldErrors"
                type="password"/>
            <div class="mt-6">
                <a-button type="primary" @click="changePassword">
                    {{ $t("changePassword") }}
                </a-button>
            </div>
        </form>
    </k-panel>
</template>

<script>
export default {
    data() {
        return {
            changePasswordForm: {
                currentPassword: null,
                newPassword: null,
                newPasswordRepeat: null
            },
            validation: {
                fieldErrors: {}
            }
        };
    },
    methods: {
        async changePassword() {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post('profile/change-password', this.changePasswordForm);
                this.changePasswordForm = {
                    currentPassword: null,
                    newPassword: null,
                    newPasswordRepeat: null
                };
                this.$message.success(this.$i18n.t('passwordChanged'));
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                    this.$scrollToErrorField();
                }
            }
        },
    }
};
</script>


